import { DropdownMenuGroup, DropdownMenuItem } from "@/components/ui/dropdown";
import { useConfirm } from "@/context/confirm-context";
import { useDeleteOrgMember } from "@/queries/organization-members";
import { OrganizationMember } from "@/types/organization-member";
import { LogOutIcon } from "lucide-react";

interface LeaveOrganizationProps {
  organizationMember: OrganizationMember;
}

const LeaveOrganization = ({ organizationMember }: LeaveOrganizationProps) => {
  const deleteOrganizationMember = useDeleteOrgMember();
  const { confirm } = useConfirm();

  const handleClick = async () => {
    const isConfirmed = await confirm({
      message:
        "Are you sure you want to leave this organization? This action cannot be undone",
    });
    if (isConfirmed) deleteOrganizationMember.mutate(organizationMember.id);
  };

  return (
    <DropdownMenuGroup>
      <DropdownMenuItem
        className="text-destructive focus:text-destructive"
        onClick={handleClick}
      >
        <LogOutIcon />
        Leave
      </DropdownMenuItem>
    </DropdownMenuGroup>
  );
};

export default LeaveOrganization;
